import { NgModule } from '@angular/core';

import { SharedModule } from '../shared';

import { HolLoginComponent } from './hol-login/HolLoginComponent';
import { HolRegisterComponent } from './hol-register/HolRegisterComponent';
import { HolChoosePasswordComponent } from './hol-register/HolChoosePasswordComponent';
import { HolForgotPasswordComponent } from './hol-forgot-password/HolForgotPasswordComponent';
import { HolChangePasswordComponent } from './hol-change-password/HolChangePasswordComponent';
import { HolSetNewPasswordComponent } from './hol-forgot-password/HolSetNewPasswordComponent';
import { LoginComponent } from './login/LoginComponent';
import { LogoutComponent } from './logout/LogoutComponent';
import { RegisterComponent } from './register/RegisterComponent';
import { ChoosePasswordComponent } from './register/ChoosePasswordComponent';
import { ForgotPasswordComponent } from './forgot-password/ForgotPasswordComponent';
import { SetNewPasswordComponent } from './forgot-password/SetNewPasswordComponent';
import { ChangePasswordComponent } from './change-password/ChangePasswordComponent';
import { AddParentComponent } from './parent/AddParentComponent';
import { AddStudentComponent } from './student/AddStudentComponent';
import { userRouting } from './UserRouting';
import { UserService } from './services/UserService';
import { PasswordService } from './services/PasswordService';
import { RegisterService } from './services/RegisterService';
import { SessionService } from './services/SessionService';
// import { HolidayService } from '../../../holiday/services/HolidayService';

@NgModule({
    imports: [
        SharedModule,
        userRouting,
    ],
    declarations: [
		HolLoginComponent,
        HolRegisterComponent,
        HolForgotPasswordComponent,
        HolChangePasswordComponent,
        HolSetNewPasswordComponent,
        HolChoosePasswordComponent,
		LoginComponent,
        LogoutComponent,
		RegisterComponent,
        ChoosePasswordComponent,
        ForgotPasswordComponent,
        SetNewPasswordComponent,
        ChangePasswordComponent,
        AddParentComponent,
        AddStudentComponent,
    ],
    providers: [
        UserService,
        SessionService,
        PasswordService,
        RegisterService,
        // HolidayService
    ]
})

export class UserModule { }


// WEBPACK FOOTER //
// ./src/common/modules/user/UserModule.ts